import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/hierarchy.action'
import UploadFile from 'api/commons/UploadFile'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'

const hierarchyUpload = (file: File) => {
  return UploadFile(file, '/areas/imports')
}

function* hierarchyUploadEffectSaga(action: any) {
  try {
    const { data } = yield call(hierarchyUpload, action.payload)

    // dispatch action to change redux state
    yield put(fromActions.Actions.hierarchyUploadSuccess(data))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* hierarchyUploadWatcherSaga() {
  yield takeLatest(fromActions.HIERARCHY_UPLOAD, hierarchyUploadEffectSaga)
}
